import styled from "styled-components";

export const InfoIcon = styled.div`
  font-size: 14px;
  &:hover {
    color: #66d7d1;
  }
`;
